import { render } from "./PageTemplate.vue?vue&type=template&id=7a880c06&scoped=true&ts=true"
import script from "./PageTemplate.vue?vue&type=script&lang=ts"
export * from "./PageTemplate.vue?vue&type=script&lang=ts"

import "./PageTemplate.vue?vue&type=style&index=0&id=7a880c06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a880c06"]])

export default __exports__